import React, { useEffect, useState } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import Chart from '../../../components/chart/Chart'
import { doc, getDoc, onSnapshot, updateDoc } from "firebase/firestore"
import {  Link, useParams } from "react-router-dom"
import { db } from '../../../firebase'
import ConfirmStatusBox from '../../../components/ConfirmStatusBox'
import { getFunctions, httpsCallable } from "firebase/functions";

const Single = ({user}) => {

  const {standardmessageId} = useParams()


  const [ standardmessageData, setStandardmessageData ] = useState("")

  const [openStatus, setOpenStatus] = useState(false)


  const getStandardmessageInfo = () => {

    onSnapshot(doc(db, "standardWhatsappMessages", standardmessageId), (doc) => {
  
     console.log("Current data: ", doc.data());
  
  
    setStandardmessageData({id: doc.id, ...doc.data()})
  
    
   });
  
  
  }

  useEffect(()=>{

    getStandardmessageInfo()
    

  }, [])



return (
  <>

<div className='single'>
      <Sidebar/>
      <div className='singleContainer'>
        
        <Navbar/>
      
        <div className="top">
            
          <div className="left">

           <div style = {{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center', paddingLeft:20, paddingRight:20, }}>

            <h2 className='title'>Standard Message Information</h2>
             <Link to={`/standardmessages/edit/${standardmessageId}`} 
                style={{ border: '1px solid gray', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:"", cursor:'pointer'}}>
                <span style={{color:'black', fontWeight:'bold'}}>Edit Details</span>
            </Link>

           </div>

            <div className='item'>

                <div className="details">
               
                  <div className='detailItem'>
                    <span className='itemKey'>Service Quality:</span>
                    <span className='itemValue'>{standardmessageData.servicequalitystatus}</span>
                  </div>

                  <div className='detailItem'>
                    <span className='itemKey'>Service Speed:</span>
                    <span className='itemValue'>{standardmessageData.servicespeedstatus}</span>
                  </div>

                  <div className='detailItem'>
                    <span className='itemKey'>Staff Behavioural:</span>
                    <span className='itemValue'>{standardmessageData.staffbehaviouralstatus}</span>
                  </div>

                   <div className='detailItem'>
                    <span className='itemKey'>Outlet Ambience:</span>
                    <span className='itemValue'>{standardmessageData.outletambiencestatus}</span>
                  </div>

                   <div className='detailItem'>
                    <span className='itemKey'>Value For Money:</span>
                    <span className='itemValue'>{standardmessageData.valueaverageformoneystatus}</span>
                  </div>

                   <div className='detailItem'>
                    <span className='itemKey'>Outlet Ambience:</span>
                    <span className='itemValue'>{standardmessageData.outletambiencestatus}</span>
                  </div>

                   <div className='detailItem'>
                    <span className='itemKey'>Customer Return Status:</span>
                    <span className='itemValue'>{standardmessageData.customeraveragereturnratestatus}</span>
                  </div>

                    <div className='detailItem'>
                    <span className='itemKey'>Whatsapp Message:</span>
                    <span className='itemValue'>{standardmessageData.whatsappmessage}</span>
                  </div>
              
                </div>

              

            </div>
          </div>
      
        </div>
      
      </div>
     
    </div>
      {/* <ConfirmStatusBox
        openStatus={openStatus}
        closeDialog={() => setOpenStatus(false)}
        statusFunction={handleStatus }
      /> */}
    </>
 
  )
}

export default Single

